"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../../../types");
const engineerAuthorizedSection = {
    label: "form.engineer.label",
    name: "engineer",
    subline: "form.engineer.subline",
    isGroup: true,
    fields: [
        {
            name: "company",
            label: "form.engineer.company",
            type: types_1.FormFieldType.full,
            required: true,
            groupName: "company",
        },
        {
            name: "name",
            label: "form.engineer.name",
            type: types_1.FormFieldType.full,
            required: true,
            groupName: "company",
            placeholder: "form.engineer.placeholder.name",
        },
        {
            name: "street_address",
            label: "form.engineer.street_address",
            type: types_1.FormFieldType.input,
            required: true,
            groupName: "address",
            placeholder: "form.engineer.placeholder.street_address",
        },
        {
            name: "address_additional",
            label: "form.engineer.address_additional",
            type: types_1.FormFieldType.input,
            groupName: "address",
            placeholder: "form.engineer.placeholder.address_additional",
        },
        {
            name: "post_code",
            label: "form.engineer.post_code",
            type: types_1.FormFieldType.input,
            required: true,
            groupName: "address",
            placeholder: "form.engineer.placeholder.post_code",
        },
        {
            name: "city",
            label: "form.engineer.city",
            type: types_1.FormFieldType.input,
            required: true,
            groupName: "address",
            placeholder: "form.engineer.placeholder.city",
        },
        {
            name: "country",
            label: "form.engineer.country",
            type: types_1.FormFieldType.countrySelect,
            required: true,
            groupName: "address",
        },
        {
            name: "state",
            label: "form.engineer.state",
            type: types_1.FormFieldType.input,
            groupName: "address",
            placeholder: "form.engineer.placeholder.state",
        },
        {
            name: "email_adress",
            label: "form.engineer.email_adress",
            type: types_1.FormFieldType.short,
            required: true,
            groupName: "contact",
            placeholder: "form.engineer.placeholder.email_adress",
        },
        {
            name: "phone",
            label: "form.engineer.phone",
            type: types_1.FormFieldType.short,
            required: true,
            groupName: "contact",
            placeholder: "form.engineer.placeholder.phone",
        },
        {
            name: "website",
            label: "form.engineer.website",
            type: types_1.FormFieldType.short,
            groupName: "contact",
            placeholder: "form.engineer.placeholder.website",
        },
    ],
    groups: [
        {
            name: "company",
            label: "form.engineer.group.company",
        },
        {
            name: "address",
            label: "form.engineer.group.address",
        },
        {
            name: "contact",
            label: "form.engineer.group.contact",
        },
    ],
};
exports.default = engineerAuthorizedSection;
